import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ComponentSync, LL_H_C } from '@nu-art/thunderstorm-frontend/index';
import './Renderer_DispoDiagnosis.scss';
import { capitalizeAllFirstLetters, MUSTNeverHappenException } from '@nu-art/ts-common';
import { ICONS } from '@app/styles';
import { ModuleFE_Advisor_ColorGroup } from '@app/advisor-frontend';
import { ModuleFE_Advisor_Reference, ModuleFE_Advisor_Variable } from '@app/advisor-frontend';
export class Renderer_DispoDiagnosis extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.diagnosis ??= nextProps.diagnosis;
        state.color ??= ModuleFE_Advisor_ColorGroup.getColorForDiseaseProfile(state.diagnosis);
        // resolve icd ref
        if (!state.icdCode) {
            const dpVariable = ModuleFE_Advisor_Variable.cache.unique(state.diagnosis.variableId);
            if (!dpVariable)
                throw new MUSTNeverHappenException(`cannot find dp variable with id ${state.diagnosis.variableId}`);
            const icdRef = ModuleFE_Advisor_Reference.cache.find(ref => dpVariable.referenceIds.includes(ref._id) && ModuleFE_Advisor_Reference.is.icdCode(ref));
            if (icdRef)
                state.icdCode = icdRef.data.id;
        }
        return state;
    }
    getStyle = () => {
        if (!this.state.color)
            return;
        return { '--dp-color': this.state.color };
    };
    render() {
        const className = _className('dispo-diagnosis', !!this.props.onClick && 'clickable');
        return _jsxs(LL_H_C, { style: this.getStyle(), className: className, onClick: () => this.props.onClick?.(), children: [_jsx("div", { className: 'color-border' }), capitalizeAllFirstLetters(this.state.diagnosis.label), _jsxs(LL_H_C, { className: 'diagnosis-tail', children: [this.state.icdCode && _jsxs(LL_H_C, { className: 'icd-tag', children: ["ICD: ", this.state.icdCode] }), !!this.props.onDelete &&
                            _jsx(ICONS.x.component, { onClick: e => {
                                    e.stopPropagation();
                                    this.props.onDelete?.();
                                } })] })] });
    }
}
//# sourceMappingURL=Renderer_DispoDiagnosis.js.map